// Components==============
import React, { createContext, useMemo, useState } from 'react';
// =========================

type GlobalRootSkillContextType = {
  rootSkillModal?: SkillEntity;
  setRootSkillModal: React.Dispatch<
    React.SetStateAction<SkillEntity | undefined>
  >;
};

export const GlobalRootSkillContext = createContext(
  {} as GlobalRootSkillContextType
);

export default function GlobalRootSkill({
  children,
}: {
  children: React.ReactNode;
}) {
  const [rootSkillModal, setRootSkillModal] = useState<SkillEntity | undefined>(
    undefined
  );

  const value = useMemo(
    () => ({
      rootSkillModal,
      setRootSkillModal,
    }),
    [rootSkillModal]
  );

  return (
    <GlobalRootSkillContext.Provider value={value}>
      {children}
    </GlobalRootSkillContext.Provider>
  );
}
